import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// AGGRESSIVE ResizeObserver error suppression for Radix UI components
// This completely prevents ResizeObserver errors from appearing in the console

// 1. Patch ResizeObserver to use debounced callback
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  const debounce = (callback, delay = 20) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        try {
          callback(...args);
        } catch (e) {
          if (!e.message.includes('ResizeObserver')) {
            throw e;
          }
        }
      }, delay);
    };
  };
  
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super(debounce((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      }));
    }
  };
}

// 2. Suppress in window error event
const errorHandler = (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
};
window.addEventListener('error', errorHandler, true);

// 3. Suppress in console.error
const originalConsoleError = console.error;
console.error = (...args) => {
  const errorString = args[0]?.toString() || '';
  if (errorString.includes('ResizeObserver')) {
    return;
  }
  originalConsoleError(...args);
};

// 4. Suppress unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('ResizeObserver') ||
    event.reason?.toString()?.includes('ResizeObserver')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
